"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intents = _interopRequireDefault(require("@ux/intents"));
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var intents = new _intents.default();
var showVisibleWithNoScrollBody = function showVisibleWithNoScrollBody(setVisibility) {
  var _document$body$style = document.body.style,
    _document$body$style$ = _document$body$style.overflowX,
    overflowX = _document$body$style$ === void 0 ? null : _document$body$style$,
    _document$body$style$2 = _document$body$style.overflowY,
    overflowY = _document$body$style$2 === void 0 ? null : _document$body$style$2;
  document.body.style.overflowX = 'hidden';
  document.body.style.overflowY = 'hidden';
  setVisibility(true);
  return function () {
    document.body.style.overflowX = overflowX;
    document.body.style.overflowY = overflowY;
  };
};
var getStyle = function getStyle(isVisible, style) {
  return _objectSpread(_objectSpread({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: intents.ux.actionHovered.backgroundColor,
    transition: 'opacity .2s ease',
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    zIndex: 1055,
    // places it in front of uxcore2 modals
    opacity: isVisible ? 0.8 : 0
  }, style), {}, {
    visibility: isVisible ? 'visible' : 'hidden'
  });
};
var DefaultLoader = function DefaultLoader(_ref) {
  var className = _ref.className,
    dataAid = _ref['data-aid'],
    style = _ref.style;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isVisible = _useState2[0],
    setVisibility = _useState2[1];
  (0, _react.useEffect)(showVisibleWithNoScrollBody.bind(_this, setVisibility));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    "data-aid": dataAid,
    style: className ? {} : getStyle(isVisible, style)
  }, /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "lg"
  }));
};
DefaultLoader.propTypes = {
  'className': _propTypes.default.string,
  'data-aid': _propTypes.default.string.isRequired,
  'style': _propTypes.default.object
};
DefaultLoader.defaultProps = {
  'data-aid': 'ml-loader'
};
var _default = exports.default = DefaultLoader;